import React, {Component} from 'react'
import PropTypes from 'prop-types'

class TrackingCarrier extends Component {
    render() {
        return (
            <td className='TrackingCarrier'>
                {this.props.trackingCarrier}
            </td>
        )
    }
}

TrackingCarrier.propTypes = {
    trackingCarrier: PropTypes.string,
}

export default TrackingCarrier
